<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Ver -->
        <el-dropdown-item command="credit-note-view">
          <i class="el-icon-view"></i> Ver
        </el-dropdown-item>

        <!-- 2. Enviar documento -->
        <el-dropdown-item command="credit-note-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Firmar / Re-intentar firma -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="credit-note-signature">
            <i class="el-icon-edit-outline"></i>
            {{ status === "timeout" ? "Re-intentar firma" : "Firmar" }}
          </el-dropdown-item>
        </template>

        <!-- Editar -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="credit-note-edit">
            <i class="el-icon-edit"></i> Editar
          </el-dropdown-item>
        </template>

        <!-- Descargar PDF -->
        <el-dropdown-item command="credit-note-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Anular -->
        <template v-if="status === 'success'">
          <el-dropdown-item command="credit-note-nuled">
            <i class="el-icon-circle-close"></i> Anular nota de crédito
          </el-dropdown-item>
        </template>

        <!-- Eliminar (siempre al final) -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="credit-note-delete" divided>
            <i class="el-icon-delete"></i> Eliminar
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <SigningConfirmModal
      :visible.sync="sriModalVisible"
      :documentNumber="creditNote ? creditNote.identification_document : ''"
      :clientName="
        creditNote && creditNote.invoice ? creditNote.invoice.client.name : ''
      "
      :amount="creditNote ? creditNote.total : 0"
      @confirm="sendSRI"
    />

    <el-dialog
      width="80%"
      title=""
      :visible.sync="nuledModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la nota de crédito?
        </h4>
        <p class="text-color-primary">
          Para completar el proceso de anulación debe ser anulada en el
          <LinkSRI />
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="nuledModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Anular" @onSaveClick="onNuled" />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="200"
      title=""
      :visible.sync="deleteModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la nota de crédito?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="deleteModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Eliminar" @onSaveClick="onDelete" />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="visibleDocumentSend = false"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="
        creditNote && creditNote.invoice && creditNote.invoice.client
          ? creditNote.invoice.client.id
          : null
      "
      :recipientName="
        creditNote && creditNote.invoice && creditNote.invoice.client
          ? creditNote.invoice.client.name
          : ''
      "
      :messageableType="'credit-note'"
      :messageableId="id"
      :moduleType="'credit-note'"
      :draftKey="'draft-creditnote-' + id"
    />
  </div>
</template>

<style lang="scss" scoped>
.img-sm {
  width: 0.8rem !important;
}
</style>

<script>
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import creditNoteService from "../services/creditNoteService";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconDownload,
  icoSignature,
  icoPreview
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";

export default {
  name: "CreditNoteOptionsByStatus",
  props: ["status", "id"],
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      iconDownload,
      icoSignature,
      icoPreview,
      sriModalVisible: false,
      nuledModalVisible: false,
      deleteModalVisible: false,
      visibleDocumentSend: false,
      creditNote: null,
      toMails: [],
      toPhone: ""
    };
  },
  methods: {
    async getCreditNote() {
      try {
        let response = await creditNoteService.getCreditNoteId(this.id);
        if (response) this.creditNote = response.data.data;
      } catch (e) {
        return false;
      }
    },
    async handleCommand(command) {
      if (!this.creditNote) {
        await this.getCreditNote();
        await this.$nextTick();
      }
      switch (command) {
        case "credit-note-view":
          this.$emit("goPage", "sales.creditNote.view", { id: this.id });
          break;
        case "credit-note-edit":
          this.$emit("goPage", "sales.creditNote.edit", { id: this.id });
          break;
        case "credit-note-signature":
          this.sriModalVisible = true;
          break;
        case "credit-note-nuled":
          this.nuledModalVisible = true;
          break;
        case "credit-note-delete":
          this.deleteModalVisible = true;
          break;
        case "credit-note-send":
          this.openSendDrawer();
          break;
        case "credit-note-download":
          this.download();
          break;
      }
    },
    async sendSRI() {
      const docId = this.creditNote.id;
      const clientName = this.creditNote.invoice
        ? this.creditNote.invoice.client.name
        : "";
      const documentNumber = this.creditNote.identification_document || "";

      this.sriModalVisible = false;
      signingEventBus.$emit("signing:start", {
        id: docId,
        clientName,
        documentNumber
      });
      this.$emit("onSigningStart", docId);

      try {
        let response = await creditNoteService.sendCreditNoteSRI({
          user_business_credit_note_id: docId
        });
        const { success, message, data } = response.data;
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: docId,
            clientName,
            documentNumber
          });
          this.creditNote = data;
          this.$emit("onSigningDone", { id: docId, data });
        } else {
          signingEventBus.$emit("signing:error", {
            id: docId,
            message: message || "Error al firmar"
          });
          this.$emit("onSigningError", docId);
        }
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: docId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        this.$emit("onSigningError", docId);
      }
    },
    async onNuled() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const docId = this.creditNote.id;
        let response = await creditNoteService
          .updateCreditNoteStatusNuled({ user_business_credit_note_id: docId })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.nuledModalVisible = false;
          });
        const { success, message, data } = response.data;
        if (success) {
          this.creditNote = data;
          this.$notifications.success({ message });
          this.$emit("onSigningDone", { id: docId, data });
        }
      } catch (e) {
        return false;
      }
    },
    async onDelete() {
      try {
        const docId = this.creditNote.id;
        let response = await creditNoteService
          .deleteCreditNoteId(docId)
          .finally(() => {
            this.deleteModalVisible = false;
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({ message });
          this.$emit("onDocDeleted", docId);
        }
      } catch (e) {
        return false;
      }
    },
    async download() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { identification_document, id } = this.creditNote;
        let response = await creditNoteService
          .creditNoteDownload({ id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (response.data)
          downloadFile(
            response.data,
            `NotaCredito - #${identification_document}`
          );
      } catch (e) {
        return false;
      }
    },
    openSendDrawer() {
      const client = this.creditNote?.invoice?.client;
      this.toMails = client && client.email ? [client.email] : [];
      this.toPhone = client && client.phone ? String(client.phone).trim() : "";
      this.visibleDocumentSend = true;
    },
    async onDocumentSend({ data }) {
      data.append("credit_note_id", this.creditNote.id);

      const emailId = `email-creditnote-${Date.now()}`;
      const clientName = this.creditNote?.invoice?.client?.name || "";
      const docNumber = this.creditNote?.identification_document || "";

      this.visibleDocumentSend = false;

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Nota de Crédito #${docNumber}`
      });

      try {
        let response = await creditNoteService.sendCreditNoteMail({ data });
        const { success, message } = response.data;
        if (success) {
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Nota de Crédito #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    }
  },
  components: {
    IconMoreOptionComponent,
    ButtonPrimaryComponent,
    WrapperSendDocumentDrawer,
    LinkSRI,
    SigningConfirmModal
  }
};
</script>
